// LDT-706 · Las casillas legales del PARQUE al contratar Playium (alta en la
// landing, renovar y comprar en el panel, alta manual del superadmin).
//
// Qué documentos lleva cada casilla lo decide
// `supabase/functions/_shared/billing/venue-legal-docs.ts`, que es lo mismo que
// exigen `billing-checkout` y `create-local`: aquí solo se le pone la ruta y se
// arma lo que el cliente manda como `legal_shown`.
import { legalDoc, type LegalDocKey } from "@/config/legal";
import { localizedPath } from "@/lib/locale";
import type { LandingLang } from "@/lib/i18n-landing";
import { shownLegalDocuments } from "@/lib/legal-acceptance";
import {
  VENUE_ATTESTATION_DOCS,
  VENUE_CHECKOUT_DOCS,
  VENUE_CONTRACT_DOCS,
  VENUE_POLICY_DOCS,
} from "../../supabase/functions/_shared/billing/venue-legal-docs";

export { VENUE_ATTESTATION_DOCS, VENUE_CHECKOUT_DOCS, VENUE_CONTRACT_DOCS, VENUE_POLICY_DOCS };

/** Idioma de los textos legales: los tres del sitio; cualquier otro, español. */
export function legalLang(language: string | null | undefined): LandingLang {
  const l = (language ?? "").slice(0, 2);
  return l === "ca" || l === "en" ? l : "es";
}

/** Ruta pública del documento en ese idioma (/terms, /ca/terms, /en/terms). */
export function venueLegalHref(key: LegalDocKey, language: string | null | undefined): string {
  return localizedPath(legalDoc(key).path, legalLang(language));
}

/**
 * `legal_shown` del checkout y de la renovación: las DOS casillas. Llamar solo
 * con las dos marcadas; lo que se manda es lo que la pantalla pinta.
 */
export function venueCheckoutShown(): Promise<Record<string, string>> {
  return shownLegalDocuments(VENUE_CHECKOUT_DOCS);
}

/** `legal_shown` de la declaración del superadmin en el alta manual. */
export function venueAttestationShown(): Promise<Record<string, string>> {
  return shownLegalDocuments(VENUE_ATTESTATION_DOCS);
}

/** Código de rechazo de las casillas que devuelven `billing-checkout` y `create-local`. */
export type VenueLegalCode = "legal_missing" | "legal_outdated";

export function venueLegalCode(body: unknown): VenueLegalCode | null {
  const code = (body as { code?: unknown } | null)?.code;
  return code === "legal_missing" || code === "legal_outdated" ? code : null;
}
